
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Jejunoileal_neuroendocrine_tumor",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Jejunoileal_neuroendocrine_tumor.vue